import { Product } from 'BrokerTsLib/src/enums'

import { Apps, type IApp } from '@/dtos'
import car from '../images/apps/car.svg'
import houseCheck from '../images/apps/houseCheck.svg'
import pinCar from '../images/apps/pinCar.svg'

export const apps: IApp[] = [
  {
    name: 'Pojištění vozidel',
    app: Apps.vehicle,
    icon: car,
    iconSize: 7,
    path: '/',
    product: Product.VehicleInsurance,
    standalone: true
  },
  {
    name: 'Pojištění vozidel - poleas',
    app: Apps.publicPoleas,
    icon: car,
    iconSize: 7,
    path: '/',
    product: Product.VehicleInsurance,
    standalone: false
  },
  {
    name: 'Pojištění doplňků',
    app: Apps.extra,
    icon: car,
    iconSize: 7,
    path: '/extra',
    product: Product.VehicleInsurance,
    standalone: false
  },
  {
    name: 'Denní POV',
    app: Apps.shortInsurance,
    icon: car,
    iconSize: 7,
    path: '/shortInsurances',
    product: Product.VehicleInsurance,
    standalone: false
  },
  {
    name: 'Pojištění vozidel - leasing',
    app: Apps.leasing,
    icon: car,
    iconSize: 7,
    path: '/leasing',
    product: Product.VehicleLeasingInsurance,
    standalone: true
  },
  {
    name: 'Pojištění vozidel - leasing',
    app: Apps.leasingSimplifiedWizard,
    icon: car,
    iconSize: 7,
    path: '/wizard',
    product: Product.VehicleLeasingInsurance,
    standalone: false
  },
  {
    name: 'Pojištění flotil',
    app: Apps.fleet,
    icon: car,
    iconSize: 7,
    path: '/fleet',
    product: Product.FleetInsurance,
    standalone: true
  },
  {
    name: 'Cestovní pojištění',
    app: Apps.travel,
    icon: pinCar,
    path: '/travel',
    product: Product.TravelInsurance,
    standalone: true
  },
  {
    name: 'Pojištění majetku a\u00A0odpovědnosti',
    app: Apps.property,
    icon: houseCheck,
    path: '/property',
    product: Product.PropertyInsurance,
    standalone: true
  },
  {
    name: 'Pojištění odpovědnosti',
    app: Apps.property,
    icon: houseCheck,
    path: '/property',
    product: Product.LiabilityInsurance,
    standalone: false
  }
]